import { render, staticRenderFns } from "./Evaluations.vue?vue&type=template&id=952531de&scoped=true&lang=html"
import script from "./Evaluations.vue?vue&type=script&lang=js"
export * from "./Evaluations.vue?vue&type=script&lang=js"
import style0 from "./Evaluations.vue?vue&type=style&index=0&id=952531de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952531de",
  null
  
)

export default component.exports